// The compiled `.bfrs`-scoped stylesheet as a string. The package also emits
// dist/style.css, but the custom-elements bundle and portaled overlays need an
// idempotent runtime fallback for apps that do not load the CSS file first.
import compiledCss from "../styles/globals.css?inline";

let documentStylesInjected = false;

export function ensureDocumentStyles(): void {
  if (documentStylesInjected || typeof document === "undefined") return;
  documentStylesInjected = true;

  const target = document.head ?? document.documentElement;
  if (!target || target.querySelector("style[data-bfrs-document-style]")) return;

  const style = document.createElement("style");
  style.setAttribute("data-bfrs-document-style", "");
  style.textContent = compiledCss;
  target.appendChild(style);
}
